import React from 'react'

function RanaghatShopmap() {
    return (
        <div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <iframe className="iframe-fluid mb-3" height="250" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=BALAJI%20SAREE%20RANAGHAT,%20KRISHNAGAR%20BYPASS%20ROAD,%20Ranaghat,%20Aistala,%20West%20Bengal%20741201%20+(BALAJI%20SAREE%20RANAGHAT,%20KRISHNAGAR%20BYPASS%20ROAD,%20Ranaghat,%20Aistala,%20West%20Bengal%20741201)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default RanaghatShopmap